import { useEffect } from 'react';

import FinList from '../FinList';

import { Helmet } from "react-helmet";

const FinListJP = () => {
	useEffect(() => {
		let pageLastViewed = localStorage.getItem("page-last-viewed");
		pageLastViewed = JSON.parse(pageLastViewed);
		pageLastViewed.finlist.jp = new Date().getTime();
		localStorage.setItem("page-last-viewed", JSON.stringify(pageLastViewed));
	}, [ ]);

	return (
		<>
			<Helmet>
				<title>FinList (JP) - Finetic App</title>
			</Helmet>
			<FinList exchange="JP" />
		</>
	);
};

export default FinListJP;
